import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { handbookStructure, contentMap } from '../../docs/handbookStructure';

const HandbookModal = ({ isOpen, onClose, initialSection = 'overview' }) => {
    const [currentSlug, setCurrentSlug] = useState(initialSection);

    useEffect(() => {
        if (isOpen && initialSection) {
            setCurrentSlug(initialSection);
        }
    }, [isOpen, initialSection]);

    if (!isOpen) return null;

    const currentContent = contentMap[currentSlug] || contentMap['overview'];

    // Render Sidebar Item
    const renderSidebarItem = (item) => {
        const isActive = currentSlug === item.slug;
        const className = 'px-3 py-2 cursor-pointer rounded-md flex items-center transition-all text-sm font-medium mb-1 ' + (isActive ? 'bg-blue-600 text-white' : 'text-stone-400 hover:bg-white/5 hover:text-stone-100');

        return (
            <div
                key={item.slug || item.title}
                className={className}
                onClick={() => item.slug && setCurrentSlug(item.slug)}
            >
                {item.icon && <span className="mr-2 text-lg">{item.icon}</span>}
                <span>{item.title}</span>
            </div>
        );
    };

    return (
        <div className="fixed inset-0 bg-black/75 backdrop-blur-sm flex justify-center items-center z-[1000]" onClick={onClose}>
            <div className="w-[90%] h-[90%] max-w-[1400px] bg-[var(--color-bg-panel)] text-[var(--color-text-primary)] border border-[var(--color-border)] rounded-xl flex overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()}>
                
                {/* Sidebar */}
                <div className="w-[280px] bg-[var(--color-bg-surface)] border-r border-[var(--color-border)] flex flex-col">
                    <div className="p-6 border-b border-[var(--color-border)]">
                        <h2 className="m-0 text-lg font-semibold flex items-center gap-2">📘 PIM Handbook</h2>
                    </div>
                    <div className="flex-1 overflow-y-auto p-4">
                        {handbookStructure.map((section, idx) => (
                            <div key={idx} className="mb-6">
                                {section.slug ? (
                                    renderSidebarItem(section)
                                ) : (
                                    <>
                                        <h3 className="text-xs uppercase text-stone-400 m-0 mb-2 ml-3 font-bold tracking-wider">{section.title}</h3>
                                        {section.items.map(sub => renderSidebarItem(sub))}
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Content */}
                <div className="flex-1 p-10 overflow-y-auto relative bg-[var(--color-bg-panel)]">
                    <button 
                        className="absolute top-5 right-5 w-8 h-8 rounded-full flex items-center justify-center cursor-pointer text-stone-400 hover:bg-white/10 hover:text-stone-100 transition-all border-none bg-transparent" 
                        onClick={onClose}
                    >
                        ✕
                    </button>
                    
                    <div className="max-w-[800px] mx-auto prose prose-invert prose-stone">
                        <ReactMarkdown>{currentContent}</ReactMarkdown>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HandbookModal;
